export const nesPallet = [
    '#000000',
    '#fcfcfc',
    '#f8f8f8',
    '#bcbcbc',
    '#7c7c7c',
    '#a4e4fc',
    '#3cbcfc',
    '#0078f8',
    '#0000fc',
    '#b8b8f8',
    '#6888fc',
    '#0058f8',
    '#0000bc',
    '#d8b8f8',
    '#9878f8',
    '#6844fc',
    '#4428bc',
    '#f8b8f8',
    '#f878f8',
    '#d800cc',
    '#940084',
    '#f8a4c0',
    '#f85898',
    '#e40058',
    '#a80020',
    '#f0d0b0',
    '#f87858',
    '#f83800',
    '#a81000',
    '#fce0a8',
    '#fca044',
    '#e45c10',
    '#881400',
    '#f8d878',
    '#f8b800',
    '#ac7c00',
    '#503000',
    '#d8f878',
    '#b8f818',
    '#00b800',
    '#007800',
    '#b8f8b8',
    '#58d854',
    '#00a800',
    '#006800',
    '#b8f8d8',
    '#58f898',
    '#00a844',
    '#005800',
    '#00fcfc',
    '#00e8d8',
    '#008888',
    '#004058',
    '#f8d8f8',
    '#787878',
];

export const battery24pallet = [
    '#f8ffba',
    '#332431',
    '#573752',
    '#784465',
    '#8f476a',
    '#a64c6c',
    '#d9577c',
    '#e04646',
    '#e6634c',
    '#e89851',
    '#e8cb58',
    '#e2ed82',
    '#fcffde',
    '#76e856',
    '#3ae056',
    '#c9fa75',
    '#b5f26b',
    '#41c47c',
    '#46b38e',
    '#4c90a1',
    '#497791',
    '#466287',
    '#424a70',
    '#303042',
];

export const pico8pallet = [
    '#000000',
    '#5F574F',
    '#C2C3C7',
    '#FFF1E8',
    '#FFEC27',
    '#FFA300',
    '#FFCCAA',
    '#AB5236',
    '#FF77A8',
    '#FF004D',
    '#83769C',
    '#7E2553',
    '#29ADFF',
    '#1D2B53',
    '#008751',
    '#00E436',
];
